if(!customElements.get('search-template')) {
  class SearchTemplate extends HTMLElement {
    constructor() {
      super();
      this.bind();
    }

    bind() {
      this.elForm = this.querySelector('[data-search-form]');
      this.elInput = this.elForm.querySelector('input[name="q"]');
      this.elSuggestions = this.querySelectorAll('[data-search-suggestion]');
      this.elClear = this.querySelector('[data-search-clear]');

      this.elForm.addEventListener('change', this.performSearch.bind(this));
      this.elForm.addEventListener('submit', (ev) => ev.preventDefault());
      this.elClear.addEventListener('click', this.clearSearch.bind(this));
      this.elSuggestions.forEach(el => el.addEventListener('click', this.setSuggestedTerm.bind(this)));
    }

    performSearch(ev) {
      ev.preventDefault();
      const url = new URL(this.elForm.action);
      url.searchParams.set('q', this.elInput.value);
      url.searchParams.set('type', 'product,article');
      
      this.classList.add('loading');
      this.fetchResults(url.href)
        .then(elSearchTemplate => {
          this.innerHTML = elSearchTemplate.innerHTML;
          this.bind();
          window.initLazyLoad();
          document.dispatchEvent(new CustomEvent('search:loaded'));
          setTimeout(() => this.classList.remove('loading'), 300);
        })
        .catch(err => {
          console.log(err);
          this.classList.remove('loading');
        })
    }

    async fetchResults(url) {
      const response = await fetch(url);
      const data = await response.text();
      const html = new DOMParser().parseFromString(data, 'text/html');
      const elSearchTemplate = html.querySelector('search-template');
      return elSearchTemplate;
    }

    clearSearch() {
      const elModal = this.closest('popup-modal');
      elModal && elModal.setAttribute('open', false);
      this.elInput.value = '';
      this.elForm.dispatchEvent(new Event('change'));
    }

    setSuggestedTerm(ev) {
      ev.preventDefault();
      const elTerm = ev.currentTarget;
      this.elInput.value = elTerm.innerHTML.trim();
      this.elForm.dispatchEvent(new Event('change'));
    }
  }
  customElements.define('search-template', SearchTemplate);
}